export default "__VITE_PUBLIC_ASSET__ad1b1abc__"